import React from "react";

const DocumentListItemView = ({ selected, item, click }) => {
    const { id, updatedAt, childName, message } = item;
    let isSelected = selected === id ? "" : "not-active";

    return (
        <div className={`document-list-item-view ${isSelected}`}>
            <button className="btn-back btn-link" onClick={click}>
                <i className="fas fa-arrow-alt-circle-left" />
            </button>{" "}
            Back to list
            <br />
            <ul>
                <li>Date sent: {updatedAt && updatedAt.split(" ")[0]}</li>
                <br />
                <li>Sent to: {childName}</li>
            </ul>
            <div className="message">
                <b>Message</b>
                <p>{message}</p>
            </div>
        </div>
    );
};

export default DocumentListItemView;
